/**
 * Generated With: pnpm x packages/api/tools/generate-shopify-rest-model.ts
 */

import { FieldType } from "../../type-system/FieldType";
import {
  ShopifyDisputeEvidenceFulfillmentKey,
  ShopifyDisputeEvidenceFulfillmentToDisputeEvidenceKey,
  ShopifyDisputeEvidenceFulfillmentToShopKey,
  ShopifyDisputeEvidenceKey,
  ShopifyShopKey,
} from "./keys";
import { ShopifyApiVersion } from "./ShopifyApiVersion";
import { ShopifyDominion } from "./ShopifyDominion";
import type { ConnectionModelSpecVersion } from "./ShopifyMetadata";
import { buildConnectionSpec } from "./ShopifyMetadata";

const specs: ConnectionModelSpecVersion = {
  key: ShopifyDisputeEvidenceFulfillmentKey,
  "2022-07": {
    name: "Shopify Dispute Evidence Fulfillment",
    fields: [
      {
        name: "Id",
        fieldType: FieldType.ID,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "id" },
        },
      },
      {
        name: "Shipping Date",
        fieldType: FieldType.DateTime,
        configuration: {
          includeTime: false,
        },
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shippingDate",
          },
        },
      },
      {
        name: "Shipping Tracking Number",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shippingTrackingNumber",
          },
        },
      },
      {
        name: "Shipping Carrier",
        fieldType: FieldType.String,
        contributorConfiguration: {
          [ShopifyDominion.id]: {
            graphQLFieldKey: "shippingCarrier",
          },
        },
      },
      {
        name: "Dispute Evidence",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeEvidenceFulfillmentToDisputeEvidenceKey,
        contributorConfiguration: {
          [ShopifyDominion.id]: { graphQLFieldKey: "disputeEvidence", skipGraphQLSelection: true },
        },
        configuration: {
          relatedModelKey: ShopifyDisputeEvidenceKey,
        },
      },
      {
        name: "Shop",
        fieldType: FieldType.BelongsTo,
        key: ShopifyDisputeEvidenceFulfillmentToShopKey,
        configuration: {
          relatedModelKey: ShopifyShopKey,
        },
      },
    ],
    // synced as part of ShopifyDispute
    syncConfig: { type: "inherit" },
  },
};

export const ShopifyDisputeEvidenceFulfillment = ({
  apiVersion,
  frameworkVersionConstraint,
  webhookTopicsForModel,
}: {
  apiVersion: ShopifyApiVersion;
  frameworkVersionConstraint?: string;
  webhookTopicsForModel?: string[];
}) => buildConnectionSpec(specs, apiVersion, frameworkVersionConstraint, webhookTopicsForModel);
